import {
  ITaxTypesDetails,
  IPaymentStatus,
  ITaxStatus,
  IPaymentTypeUpdate,
  IPaymentTypesDetails,
  ITransacationDetails,
  INvoiceFile,
  IClientInvoice,
} from 'wisestep-api';

import { IOption } from '../../../components/SettingsIndex';
import { IBreadCrumbsList } from '../../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';

export const invoiceSettingsIndexOptions: IOption[] = [
  { label: 'Payment Type', url: '/invoice/settings/payment_type' },
  { label: 'Tax Type', url: '/invoice/settings/tax_type' },
  { label: 'Invoice Type', url: '/invoice/settings/invoice_type' },
  { label: 'Invoice Extra', url: '/invoice/settings/invoice_extra' },
  { label: 'Customize Invoice Fields', url: '/invoice/settings/customize-invoice-fields' },
  { label: 'Create Invoice Template', url: '/invoice/template' },
  { label: 'Terms and Conditions', url: '/invoice/settings/terms-and-conditions' },
];

export const invoiceSettingsDefaultPayload: IPaymentTypesDetails = {
  name: '',
  isActive: true,
  id: '',
  workspaceId: '',
  createdBy: '',
  createdOn: null,
  modifiedBy: '',
  modifiedOn: null,
  createdByName: '',
  modifiedByName: '',
  description: '',
  isApproved: true,
};

export enum ApplyTo {
  Taxes = 'Taxes',
  Invoice = 'Invoice',
}

export const updateStatusQuery: IPaymentStatus = {
  isActive: false,
};

export const updateTaxStatusQuery: ITaxStatus = {
  isActive: false,
};

export const updatePaymentTypeQuery: IPaymentTypeUpdate = {
  name: '',
  description: '',
};

export const invoiceTaxSettingsDefaultPayload: ITaxTypesDetails = {
  name: '',
  isActive: true,
  id: '',
  workspaceId: '',
  createdBy: '',
  createdOn: null,
  modifiedBy: '',
  modifiedOn: null,
  createdByName: '',
  modifiedByName: '',
  applyToTaxes: [],
  applyTo: ApplyTo.Invoice,
  rate: '',
};

export interface IBankAccountObject {
  bankName: string;
  currencyEntityId: string;
  currency: string;
  id: string;
}

export const transcationDetailDefaultPayload: ITransacationDetails = {
  id: '',
  amount: '',
  paymentReferenceId: '',
  transactionComment: '',
  paymentDate: null,
  currencyId: '',
  clientId: '',
  ourEntityBankId: '',
  paymentTypeId: '',
  workspaceId: '',
  createdBy: '',
  createdOn: null,
  modifiedBy: '',
  modifiedOn: null,
  createdByName: '',
  modifiedByName: '',
  clientInvoiceId: '',
};

export interface IInvoiceObject {
  invoiceCode: string;
  total: number;
  remainingAmount: number;
  comment?: string;
  paid: number;
  ourEntityId?: string | any;
}

export interface IReceiptTypeList {
  label: string;
  value: string;
}

export interface transcationHeaderList {
  labeHeaderl: string;
  accessor: string;
}

export interface IInvoiceDataList {
  invoice_code: string;
  amount: number;
  adjustment: number;
  amountOs: number;
  commentsInfo: string;
  invoiceCurrency: string;
}

export interface IInvoiceDataResponse {
  invoice_code: string;
  total: number;
  paid: number;
  remainingAmount: number;
  commentsInfo: string;
  invoiceCode: string;
  dueDate: Date;
  currencySymbol: string;
}

export interface IDefaultValue {
  fieldOne?: string;
  fieldTwo?: string;
  toggled?: boolean;
  bankName?: string;
  transcationDate?: string;
  paymentReference?: string;
  transcationAmount?: string;
  transactionComment?: string;
  currencyType?: string;
  exchangeRate?: string;
}

export const defaultClientInvocieFilePayload: INvoiceFile = {
  id: '',
  clientId: '',
  file: { name: '', location: '' },
  invoiceId: '',
  createdBy: '',
  modifiedBy: '',
  createdOn: null,
  modifiedOn: null,
  createdByName: '',
  documentName: '',
  documentDescription: '',
};

export interface IDrawerDocument {
  invoiceId: string;
  invoice?: IClientInvoice | undefined;
}

export interface IDrawerWithCheckbox {
  openDialog: boolean;
  closeDialog(): void;
  invoiceId: string;
}

export type TitleAndBreadCrumbs = {
  Title: string;
  BreadcrumbsList: IBreadCrumbsList[];
};

export type InVoiceType = 'PAYMENT_TYPE' | 'TAX_TYPE';

export const InvoiceBreadCrumbListAndTitle: Record<InVoiceType, TitleAndBreadCrumbs> = {
  PAYMENT_TYPE: {
    Title: 'Payment Type',
    BreadcrumbsList: getSettingBreadCrumbList(
      ISettingBreadCrumbTypes.INVOICE,
      Pages['PAYMENT_TYPE']
    ),
  },
  TAX_TYPE: {
    Title: 'Tax Type',
    BreadcrumbsList: getSettingBreadCrumbList(ISettingBreadCrumbTypes.INVOICE, Pages['TAX_TYPE']),
  },
};
